var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 64 64",
    id: "fill",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#3063d5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 14,
    style: {
      fill: "#cfcfd9"
    },
    width: 6,
    x: 4,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    height: 20,
    style: {
      fill: "#cfcfd9"
    },
    width: 6,
    x: 14,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    height: 26,
    style: {
      fill: "#cfcfd9"
    },
    width: 6,
    x: 24,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    height: 30,
    style: {
      fill: "#cfcfd9"
    },
    width: 6,
    x: 34,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 35,
    style: {
      fill: "#cfcfd9"
    },
    width: 6,
    x: 44,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    height: 42,
    style: {
      fill: "#cfcfd9"
    },
    width: 6,
    x: 54,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    height: 40,
    style: {
      fill: "#d9dae2"
    },
    width: 4,
    x: 54,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    height: 33,
    style: {
      fill: "#d9dae2"
    },
    width: 4,
    x: 44,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    height: 28,
    style: {
      fill: "#d9dae2"
    },
    width: 4,
    x: 34,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 24,
    style: {
      fill: "#d9dae2"
    },
    width: 4,
    x: 24,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    height: 18,
    style: {
      fill: "#d9dae2"
    },
    width: 4,
    x: 14,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#d9dae2"
    },
    width: 4,
    x: 4,
    y: 47
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53 3 54.314 5.663 57.253 6.09 55.127 8.163 55.629 11.09 53 9.708 50.371 11.09 50.873 8.163 48.747 6.09 51.686 5.663 53 3",
    style: {
      fill: "#3063d5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38 11 41 14 34 21 21 21 6 36 9 39 23 25 36 25 44 17 47 20 47 11 38 11",
    style: {
      fill: "#3063d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,14l-7,7H21L6,36l3,3L23,25H36l5-5a4.242,4.242,0,0,0,0-6Z",
    style: {
      fill: "#3063d5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5 52 5 48 9 48 5 52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 46 15 42 19 42 15 46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25 40 25 36 29 36 25 40",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35 36 35 32 39 32 35 36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45 31 45 27 49 27 45 31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55 24 55 20 59 20 55 24",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,62H4a1,1,0,0,1-1-1V47a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V61A1,1,0,0,1,10,62ZM5,60H9V48H5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,62H14a1,1,0,0,1-1-1V41a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V61A1,1,0,0,1,20,62Zm-5-2h4V42H15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,62H24a1,1,0,0,1-1-1V35a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V61A1,1,0,0,1,30,62Zm-5-2h4V36H25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40,62H34a1,1,0,0,1-1-1V31a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V61A1,1,0,0,1,40,62Zm-5-2h4V32H35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50,62H44a1,1,0,0,1-1-1V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V61A1,1,0,0,1,50,62Zm-5-2h4V27H45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60,62H54a1,1,0,0,1-1-1V19a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V61A1,1,0,0,1,60,62Zm-5-2h4V20H55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.629,12.09a1.015,1.015,0,0,1-.466-.114L53,10.838l-2.163,1.138a1,1,0,0,1-1.451-1.055L49.8,8.512l-1.75-1.706A1,1,0,0,1,48.6,5.1l2.417-.352L52.1,2.558a1.04,1.04,0,0,1,1.792,0l1.083,2.191L57.4,5.1a1,1,0,0,1,.555,1.705L56.2,8.512l.413,2.409a1,1,0,0,1-.985,1.169ZM53,8.708a1,1,0,0,1,.466.115l.835.439-.159-.93a1,1,0,0,1,.287-.885l.675-.658-.933-.136a1,1,0,0,1-.753-.548L53,5.259l-.418.846a1,1,0,0,1-.753.548l-.933.136.675.658a1,1,0,0,1,.287.885l-.159.93.835-.439A1,1,0,0,1,53,8.708Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.af79bab9d3c52eb501d25fad2f451de9.svg";
export { ForwardRef as ReactComponent };